AppEventEmitter = function () {};
/** @var {} heir */
heir.inherit(AppEventEmitter, EventEmitter);

ControllerEventEmitter = function () {};
heir.inherit(ControllerEventEmitter, AppEventEmitter);
ControllerEventEmitter.prototype.addListener = function (evt, listener) {
    AppEventEmitter.prototype.addListener.call(this, evt, listener);
};
ControllerEventEmitter.prototype.emitEvent = function (evt, args) {
    args = args || {};
    AppEventEmitter.prototype.emitEvent.call(this, evt, [ args ]);
};

app = {};
